import type { ISegmentModalWrapper } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import type { FC } from "react";
import { SegmentModal } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-modals/SegmentModal";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";

export const ChangeWebsiteModal: FC<ISegmentModalWrapper> = ({ isOpen, onConfirm, onModalClose }) => (
    <SegmentModal
        onModalClose={onModalClose}
        isOpen={isOpen}
        onConfirm={onConfirm}
        modalTitle={"segmentsWizard.changeWebsiteAddress.title"}
        modalText={"segmentsWizard.changeWebsiteAddress.description"}
        modalDisclaimer={"segmentsWizard.confirmChangeDialog.actionDisclaimer"}
        modalConfirmButtonLabel={"segmentsWizard.changeWebsiteAddress.confirm.button"}
        confirmButtonType={buttonTypes.WARNING}
        cancelButtonType={buttonTypes.FLAT_DARK}
        modalWidth={550}
        colorDisclaimer={true}
    />
);
